// import "./tablewater.css"
import React, { useContext, useEffect, useState } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPencil} from '@fortawesome/free-solid-svg-icons'


const TableWater = ({ data= [], handleEdit }) => {
    return (
        <div className="overflow-x-auto">
            <table className="min-w-full border-collapse border border-gray-300">
                <thead>
                    <tr className="bg-gray-200">
                        <th className="border border-gray-300 px-4 py-2">ユーティリティID</th>
                        <th className="border border-gray-300 px-4 py-2">名称</th>
                        <th className="border border-gray-300 px-4 py-2">種類</th>
                        <th className="border border-gray-300 px-4 py-2">必要流量[L/min]</th>
                        <th className="border border-gray-300 px-4 py-2">接続口径[A呼称/B呼称]</th>
                        <th className="border border-gray-300 px-4 py-2">備考</th>
                        <th className="border border-gray-300 px-4 py-2">最終更新者</th>
                        <th className="border border-gray-300 px-4 py-2"></th>
                    </tr>
                </thead>
                <tbody>
                    {data.length > 0 ? (
                        data.map((row, index) => (
                            <tr key={index} className="hover:bg-gray-100">
                                <td className="border border-gray-300 px-4 py-2">{row.uttID}</td>
                                <td className="border border-gray-300 px-4 py-2">{row.waterName}</td>
                                <td className="border border-gray-300 px-4 py-2">{row.waterType}</td>
                                <td className="border border-gray-300 px-4 py-2">{row.capacity}</td>
                                <td className="border border-gray-300 px-4 py-2">{row.connectionSize}</td>
                                <td className="border border-gray-300 px-4 py-2">{row.remark1}</td>
                                <td className="border border-gray-300 px-4 py-2">{row.updatedBy}</td>
                                <td>
                                    <button onClick={() => handleEdit(row, 'water')}>
                                        <FontAwesomeIcon icon={faPencil} />
                                        {/* 編集 */}

                                    </button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="3" className="text-center border border-gray-300 px-4 py-2">
                                データがありません
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default TableWater;
